import React from 'react';
import '../styles/footer.css';

const Footer = () => (
  <div className="footer-container">
    <section className="bar-ball-container" id="bar-ball-container">
      <div className="bar">
        <section className="ball" />
      </div>
    </section>
  </div>
);

export default Footer;
